import React from "react";
import {
	Provider
} from "react-redux";
import {
	StyledEngineProvider
} from "@mui/material";
import {
	createTheme,
	ThemeProvider
} from "@mui/material/styles";
import {
	ReactNotifications
} from 'react-notifications-component'
import {
	WebAppProvider
} from '@vkruglikov/react-telegram-web-app';
import theme from "./theme";
import MainRoute from "./route";
import store from "./redux/store";
import { BuyNumberProvider } from "./contexts/BuyNumberContext";

const App = () => {
	React.useEffect(() => {
		window.Telegram.WebApp.ready();
		window.Telegram.WebApp.expand();
		window.Telegram.WebApp.disableVerticalSwipes();
		setTimeout(() => {
			handleDisabledScrollClose();
		}, 1000)
	}, []);
	const handleDisabledScrollClose = () => {
		const overflow = 100
		document.body.style.overflowY = 'hidden'
		document.body.style.marginTop = `${overflow}px`
		document.body.style.height = window.innerHeight + overflow + "px"
		document.body.style.paddingBottom = `${overflow}px`
		window.scrollTo(0, overflow);
	}

	return (
		<WebAppProvider options={{smoothButtonsTransition: true}}>
			<StyledEngineProvider injectFirst>
				<ThemeProvider theme={createTheme(theme)}>
					<Provider store={store}>
						<BuyNumberProvider>
							<ReactNotifications/>
							<MainRoute/>
						</BuyNumberProvider>
					</Provider>
				</ThemeProvider>
			</StyledEngineProvider>
		</WebAppProvider>
	)
}

export default App
